import { useEffect } from 'react';

import { useTaskFrameStore, useToolPermissionStore } from '@/store';

const Working = () => {
  const { currentFrame } = useTaskFrameStore();
  const { setPermission } = useToolPermissionStore();

  useEffect(() => {
    setPermission({
      labeling: {
        readable: true,
        updatable: true,
        acceptable: true,
      },
      labelingReview: {
        readable: true,
        updatable: false,
        acceptable: false,
      },
      preAnnotation: {
        acceptable: true,
      },
      aiAssist: {
        acceptable: true,
      },
    });
  }, [currentFrame?.frameSeq, currentFrame?.workState]);

  return <></>;
};

export default Working;
